import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * PasswordInput — text/password toggle with a soberly-styled eye icon.
 * Shared between the admin login form and the "change password" form so
 * every password field behaves the same.
 */
export const PasswordInput = ({
  value,
  onChange,
  required = false,
  autoComplete = "current-password",
  testId,
  className = "",
  placeholder = "",
}) => {
  const [shown, setShown] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <input
        data-testid={testId}
        type={shown ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        autoComplete={autoComplete}
        placeholder={placeholder}
        className="w-full pr-10 px-3 py-2.5 rounded border border-[var(--line-strong)] focus:outline-none focus:border-[var(--red)]"
      />
      <button
        type="button"
        onClick={() => setShown((s) => !s)}
        aria-label={shown ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        aria-pressed={shown}
        data-testid={testId ? `${testId}-toggle` : undefined}
        tabIndex={-1}
        className="absolute top-1/2 right-2 -translate-y-1/2 h-7 w-7 grid place-items-center rounded text-neutral-400 hover:text-[var(--red)] focus:outline-none focus:text-[var(--red)] transition-colors"
      >
        {shown ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};
